import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalCancelButton, ModalCloseButton } from '@dreryk/react-components';

type GenerateStatisticsModalButtonsProps = {
   handleClose: VoidFunction;
   shouldConfirmExit: boolean;
};

export const GenerateStatisticsModalButtons = (props: GenerateStatisticsModalButtonsProps): JSX.Element => (
   <>
      <ModalCancelButton
         label={commonTranslationKeys.cancel}
         onClick={props.handleClose}
         shouldConfirmExit={props.shouldConfirmExit}
      />
      <ModalCloseButton onClick={props.handleClose} shouldConfirmExit={props.shouldConfirmExit} />
   </>
);
